<template>
  <b-form-input
    readonly
    :type="'text'"
    :name="inputName"
    style="background-color: transparent;"
    placeholder="Choose date"
  ></b-form-input>
</template>

<script>
import $ from "jquery";
import moment from "moment";

export default {
  name: "datepicker",
  props: {
    start: { type: String },
    end: { type: String },
    type: { type: String },
    disable: { type: Boolean },
    autoUpdate: { type: Boolean },
    timePicker: { type: Boolean },
    timePicker24: { type: Boolean },
    name: {
      type: String,
      default: "daterange"
    }
    ,
    // maximum allowed years for the selected range (default: 1 year)
    maxYears: {
      type: [Number, String],
      default: 1,
      validator(value) {
        const n = Number(value);
        return Number.isFinite(n) && n >= 0;
      }
    }
  },
  data() {
    return {
      mounting: true,
      startDate: null,
      endDate: null,
      disableds: this.disable,
      autoUpdates: this.autoUpdate !== undefined ? this.autoUpdate : true,
      timePickers: this.timePicker !== undefined ? this.timePicker : false,
      types: this.type,
      inputName: this.name,
      formats:
        this.timePicker !== undefined && this.timePicker
          ? "YYYY-MM-DD HH:mm:ss"
          : "YYYY-MM-DD"
    };
  },
  watch: {
    disable(newValue) {
      this.disableds = newValue;
      const datepicker = $(`input[name="${this.inputName}"]`);
      this.applyDatePickerLogic(datepicker);
    },
    start(newValue) {
      const format = this.formats;
      const datepicker = $(`input[name="${this.inputName}"]`);
      // treat both 'clear' and 'clear-auto' as clear-type for clearing behavior
      const isClear = this.types == "clear" || this.types == "clear-auto";

      if (!newValue) {
        this.startDate = moment().startOf("day").format(format);
        const defaultStartDate = moment().startOf("day");
        datepicker.data("daterangepicker").setStartDate(defaultStartDate);
      } else {
        this.startDate = moment(newValue).format(format);
        datepicker.data("daterangepicker").setStartDate(this.startDate);
      }

      if (!newValue && isClear) {
        this.handleFilled({ start: null, end: null });
      }
      // ensure start/end obey maxYears if both present
      this.clampDatepickerRange(datepicker);
    },
    end(newValue) {
      const format = this.formats;
      const datepicker = $(`input[name="${this.inputName}"]`);
      // treat both 'clear' and 'clear-auto' as clear-type for clearing behavior
      const isClear = this.types == "clear" || this.types == "clear-auto";

      if (!newValue) {
        this.endDate = moment().endOf("day").format(format);
        const defaultEndDate = moment().endOf("day");
        datepicker.data("daterangepicker").setEndDate(defaultEndDate);
      } else {
        this.endDate = moment(newValue).format(format);
        datepicker.data("daterangepicker").setEndDate(this.endDate);
      }

      if (!newValue && isClear) {
        this.handleFilled({ start: null, end: null });
      }
      // ensure start/end obey maxYears if both present
      this.clampDatepickerRange(datepicker);
    }
  },
  methods: {
    // enforce maxYears constraint: if end is after start + maxYears, clamp end
    // Accepts maxYears = 0. Coerce prop to Number and fallback to 1 only on invalid values.
    enforceMaxRange(start, end) {
      if (!start || !end) return { start, end, clamped: false };
      const parsed = Number(this.maxYears);
      const maxYears = Number.isFinite(parsed) ? parsed : 1;
      
      // Calculate max days: 365 days per year (including start date)
      const maxDays = maxYears * 365 - 1;
      const maxEnd = moment(start).add(maxDays, "days").endOf("day");
      
      if (end.isAfter(maxEnd)) {
        return { start, end: maxEnd, clamped: true };
      }
      return { start, end, clamped: false };
    },

    // helper to clamp the current daterangepicker instance (used from watchers)
    clampDatepickerRange(datepicker) {
      try {
        if (!datepicker || !datepicker.data || !datepicker.data("daterangepicker")) return;
        const picker = datepicker.data("daterangepicker");
        const start = picker.startDate;
        const end = picker.endDate;
        const { end: clampedEnd, clamped } = this.enforceMaxRange(start, end);
        if (clamped) {
          picker.setEndDate(clampedEnd);
          // also update internal endDate string representation
          this.endDate = clampedEnd.format(this.formats);
        }
      } catch (e) {
        // swallow errors - defensive
      }
    },
    handleValue() {
      const format = this.formats;
      const isClearAuto = this.type == "clear-auto";

      if (this.start && this.end) {
        this.disableds = this.disable;
        this.autoUpdates = this.autoUpdate;
        this.timePickers = this.timePicker;
        this.timePickers24 = this.timePicker24;
        this.endDate = moment(this.end, format);
        this.startDate = moment(this.start, format);
      } else if ((this.type == "clear" || isClearAuto) && !this.start && !this.end) {
        this.disableds = this.disable;
      } else {
        this.disableds = this.disable;
        this.endDate = moment().startOf("day").format(format);
        this.startDate = moment().endOf("day").format(format);
      }
    },
    applyDatePickerLogic(datepicker) {
      const defaultStartDate = this.mounting
        ? moment().startOf("day")
        : moment().startOf("day");
      const defaultEndDate = this.mounting
        ? moment().endOf("day")
        : moment().endOf("day");

      // only disable when disableds is true and the type explicitly indicates clearing behavior
      const isClearType = this.types === "clear" || this.types === "clear-auto";
      datepicker.prop("disabled", this.disableds && isClearType);
      datepicker.data("daterangepicker").setStartDate(defaultStartDate);
      datepicker.data("daterangepicker").setEndDate(defaultEndDate);
      // If this is 'clear-auto' and the component was initialized without start/end props,
      // keep the visible input empty while still having autoUpdateInput enabled.
      if (this.types === "clear-auto" && !this.start && !this.end) {
        try {
          datepicker.val("");
        } catch (e) {
          // swallow any errors silently
        }
      }
    },
    handleParseDate(val) {
      return moment(val);
    },
    handleFilled(value) {
      const format = this.formats;
      const datepicker = $(`input[name="${this.inputName}"]`);

      if (value.start && value.end) {
        datepicker.val(
          `${value.start.format(format)} - ${value.end.format(format)}`
        );
      } else {
        datepicker.val("");
      }
    }
  },
  mounted() {
    this.handleValue();

    const onDateSelected = (start, end) => {
      const format = this.formats;

      if (start && end) {
        // enforce max range and update picker UI if clamped
        const { start: s, end: e, clamped } = this.enforceMaxRange(start, end);
        if (clamped) {
          const datepicker = $(`input[name="${this.inputName}"]`);
          // update the picker's end date to the clamped value
          if (datepicker && datepicker.data && datepicker.data("daterangepicker")) {
            datepicker.data("daterangepicker").setEndDate(e);
          }
        }

        // Respect time picker selections; default to end-of-day for date-only ranges
        let finalEnd = this.timePickers ? moment(e).second(59) : moment(e).endOf("day");

        this.$emit("picker", {
          startDate: s.format(format),
          endDate: finalEnd.format(format)
        });

        // trigger filled handler for both clear and clear-auto types (they both clear when requested)
        if (this.types == "clear" || this.types == "clear-auto") this.handleFilled({ start: s, end: finalEnd });
      }
    };

    $(() => {
      const isTypeClear = this.types == "clear";
      // only suppress autoUpdateInput when the type is exactly 'clear'
      const isTypeClearValue = this.autoUpdates || !(isTypeClear && !this.startDate && !this.endDate);

      const datepickerOptions = {
        ranges: {
          Today: [moment().startOf("day"), moment().endOf("day")],
          Yesterday: [
            moment().subtract(1, "days").startOf("day"),
            moment().subtract(1, "days").endOf("day")
          ],
          "Last 7 Days": [
            moment().subtract(6, "days").startOf("day"),
            moment().endOf("day")
          ],
          "Last 30 Days": [
            moment().subtract(29, "days").startOf("day"),
            moment().endOf("day")
          ],
          "This Month": [
            moment().startOf("month").startOf("day"),
            moment().endOf("month").endOf("day")
          ],
          "Last Month": [
            moment().subtract(1, "month").startOf("month").startOf("day"),
            moment().subtract(1, "month").endOf("month").endOf("day")
          ]
        },
        alwaysShowCalendars: true,
        readonly: true,
        autoUpdateInput: isTypeClearValue,
        startDate: this.startDate,
        endDate: this.endDate,
        timePicker24Hour: this.timePicker24,
        locale: {
          applyLabel: "Apply Date",
          format: this.formats
        }
      };

      if (!this.types) datepickerOptions.maxDate = moment();
      if (this.timePickers) datepickerOptions.timePicker = true;
      if (this.timePickers24) datepickerOptions.timePicker24Hour = true;

      const datepicker = $(`input[name="${this.inputName}"]`);

      // ✅ hanya register sekali (callback bawaan)
      datepicker.daterangepicker(datepickerOptions, (start, end) => {
        onDateSelected(start, end);
      });

      // ⭐ FIX UI TIME = 00:00 kalau props start / end = ""
      // datepicker.on("show.daterangepicker", (ev, picker) => {
      //   const isEmptyStart = this.start === "";
      //   const isEmptyEnd = this.end === "";

      //   if (isEmptyStart || isEmptyEnd) {
      //     const zeroTime = moment(picker.startDate).startOf("day");

      //     picker?.setStartDate(zeroTime);
      //     picker?.setEndDate(zeroTime);

      //     if (picker.timePicker) {
      //       picker.container.find(".hourselect").val("0").trigger("change");
      //       picker.container.find(".minuteselect").val("0").trigger("change");
      //       picker.container.find(".secondselect").val("0").trigger("change");
      //     }
      //   }
      // });

      // ✅ Handle apply event untuk memastikan callback dipanggil bahkan jika date tidak berubah
      datepicker.on('apply.daterangepicker', (ev, picker) => {
        onDateSelected(picker.startDate, picker.endDate);
      });

      this.applyDatePickerLogic(datepicker);

      this.mounting = false;
    });
  }
};
</script>
